module.exports = __webpack_public_path__ + "media/images/lightbox/thumb-v-v-1-29a237499005c67adbe3284fae81d42d.jpg";